import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

// ANT DESIGN
import { Row, Typography, Col, Button, Tooltip, Divider, Collapse } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import cnt from "../../../../../../services/definedConstant";
import { BOM } from "../../../../../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const { Title, Text } = Typography;
const { Panel } = Collapse;

function RelationshipInfo(props) {
  const { currentCustomerObj, relationshipDetails, session } = props;

  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleNewRelationship = () => {
    navigate("/new-relationship", { state: currentCustomerObj });
  };

  function handleRelationshipEdit(param) {
    console.log(param);
    // return;
    navigate("/edit-relationship", {
      state: {
        ...currentCustomerObj,
        relationshipId: param.id,
      },
    });
  }

  const handleOnDelete = (param) => {
    let action = "Delete  ";
    let label = param.firstName;
    // console.log(currentCustomerObj); return

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${apiConfig.Clients}/${currentCustomerObj.id}/familymembers/${param.id}`;

        const body = {
          method: "DELETE",
          session,
        };

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteRelationshipMsg);
              navigate("/cst0100");
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/cst0100");
              setIsLoading(false);
            },
          }
        );
      }
    );
  };

  return (
    <>
      {BOM.HasPermission("CREATE_FAMILYMEMBERS") && (
        <Button
          type="primary"
          shape="round"
          className="of-primaryBtnColor"
          onClick={handleNewRelationship}
        >
          <PlusCircleOutlined />
          &nbsp;{labelConfig.add}
        </Button>
      )}
      <Divider style={{ marginTop: 10, marginBottom: 30 }} />

      <Row>
        {relationshipDetails.map((item, index) => {
          return (
            <Col span={12} key={index} style={{ padding: "0px 8px" }}>
              <RelationshipInfoSlab
                relationshipDetails={item}
                handleRelationshipEdit={handleRelationshipEdit}
                handleOnDelete={() => handleOnDelete(item)}
              />
            </Col>
          );
        })}
      </Row>
    </>
  );
}

export default RelationshipInfo;

function RelationshipInfoSlab(props) {
  const { relationshipDetails, handleRelationshipEdit, handleOnDelete } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {relationshipDetails.relationship}
          </Title>
        }
        key="1"
      >
        <Row
          style={{
            marginBottom: "8px",
          }}
        >
          {BOM.HasPermission("DELETE_FAMILYMEMBERS") && (
            <Button
              style={{
                width: "15vh",
                color: "white",
                backgroundColor: "#3E2336",
                marginLeft: "auto",
              }}
              onClick={handleOnDelete}
            >
              Delete
            </Button>
          )}
          {BOM.HasPermission("UPDATE_FAMILYMEMBERS") && (
            <Button
              style={{
                width: "15vh",
                color: "white",
                backgroundColor: "#3E2336",
                marginLeft: "10px",
              }}
              onClick={() => handleRelationshipEdit(relationshipDetails)}
            >
              Edit
            </Button>
          )}
        </Row>

        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>First Name</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {relationshipDetails.firstName}
              </Text>
            </Col>
          </Row>
        </div>

        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Middle Name</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {relationshipDetails.middleName}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Last Name</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {relationshipDetails.lastName}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Qualifications</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {relationshipDetails.qualification}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Mobile Number</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {relationshipDetails.mobileNumber}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.bvn}</Text>
            </Col>
            <Col span={12} style={{ padding: 10 }}>
              <Text style={{ color: "#b8b8b8" }}>
                {relationshipDetails.bvn ?? "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.nin}</Text>
            </Col>
            <Col span={12} style={{ padding: 10 }}>
              <Text style={{ color: "#b8b8b8" }}>
                {relationshipDetails.nin ?? "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Age</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {relationshipDetails.age}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Is Dependent?</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {relationshipDetails?.isDependent === true
                  ? "true"
                  : relationshipDetails?.isDependent === false
                  ? "false"
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Marital Status</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {relationshipDetails.maritalStatusId}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Gender</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {relationshipDetails.gender}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Profession</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {relationshipDetails.professionId}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>Date of Birth</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {BOM.DateTime(relationshipDetails.dateOfBirth, "only-date")}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}
